"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

/**
 * @file genDynamicFnName.ts 生成一个随机function name
 * @author wangning25 <wangning25@baidu.com> on 2021/10/06.
 */

/**
 * 生成一个随机function name
 * @returns {string}
 */
var genDynamicFnName = function genDynamicFnName(actionName) {
  var _context;

  return (0, _concat.default)(_context = "__BMLS__".concat(actionName, "__")).call(_context, Date.now());
};

var _default = genDynamicFnName;
exports.default = _default;